import { FC, ReactNode, useMemo } from "react";
import style from "./GenericErrorPage.module.scss";
import { DeviceMobileIcon, Icon } from "@phosphor-icons/react";
import Typhography from "../../shared/Typhography/Typhography";
import CustomButton from "../../shared/CustomButton/CustomButton";
import { useCustomKeycloak } from "../../hooks/useCustomKeycloak";
import { useAppSelector } from "../../store";
import { USER_TYPES } from "../../enums/user";

export const GenericErrorPage: FC<{
  title: string;
  description: string;
  Icon?: Icon;
}> = ({ title, description, Icon }) => {
  const entities = useAppSelector((st) => st.me.entities);

  const { keycloak } = useCustomKeycloak();
  return (
    <div className={style.pageContainer}>
      <div className={style.backgroundImage}></div>
      <div className={style.contentContainer}>
        {Icon && <Icon color="#FFD15A" size={"100"} />}
        {title && (
          <Typhography size="bold-40" className={style.description}>
            {title}
          </Typhography>
        )}
        {description && (
          <Typhography size="medium-20" className={style.description}>
            {description}
          </Typhography>
        )}
        <CustomButton
          className="mt-5"
          onClick={() => {
            keycloak.logout();
          }}
        >
          Logout
        </CustomButton>
      </div>
    </div>
  );
};
